export enum ELSProps {
  token = "token",
  videoAdViewTimestamps = "videoAdViewTimestamps",
  adsgramLastClickDate = "adsgramLastClickDate",
  hideTraffyContainerUntil = "hideTraffyContainerUntil",
}
